<div class="ai-assistant-container" (mouseenter)="stopReset()" (mousemove)="move($event)" (mouseleave)="leave($event)">
  <div class="gradient-border-mask" #gradientBorderMask [style.background]="gradient()"></div>
  <div class="ai-assistant-content">
    <div class="info-container">
      @if (aiAssistant().assistant.avatarUrl || aiAssistant().decoration?.avatarIconUrl) {
        <glxy-avatar
          class="assistant-avatar"
          [src]="aiAssistant().assistant.avatarUrl || aiAssistant().decoration?.avatarIconUrl"
        ></glxy-avatar>
      } @else {
        <glxy-avatar
          class="assistant-avatar"
          [svgIcon]="aiAssistant().decoration?.defaultAvatarIcon ?? defaultAvatarIcon"
          [useGrayScale]="isDisabled()"
        ></glxy-avatar>
      }
      <div class="text-container">
        <p class="title">{{ aiAssistant().assistant.name }}</p>
        @if (aiAssistant().subtitleKey) {
          <p class="subtitle">{{ aiAssistant().subtitleKey | translate }}</p>
        }
      </div>
    </div>
    @if (aiAssistant().autonomyRating) {
      <ai-rating-badge
        [aiAssistant]="aiAssistant()"
        [label]="'AI_ASSISTANT.AUTONOMY_LABEL' | translate"
        [value]="aiAssistant().autonomyRating"
        [max]="4"
      ></ai-rating-badge>
    }
    <p class="description">
      {{ aiAssistant().descriptionKey | translate }}
    </p>
    @let aiConnections = uniqueConnections();
    @if (aiConnections && aiConnections.length > 0) {
      <div class="connections-container">
        @for (aiConnection of aiConnections; track aiConnection) {
          @if (aiConnection.connection) {
            @if (aiConnection.connection.iconUrl) {
              <img
                class="availability-icons"
                [class.greyscale]="aiConnection.isGreyscale"
                alt="{{ aiConnection.connection.connectionTypeName }}"
                [src]="aiConnection.connection.iconUrl"
                [glxyTooltip]="aiConnection.connection.connectionTypeName + ' ' + (aiConnection.tooltip | translate)"
              />
            } @else if (aiConnection.connection.connectionType !== ConnectionType.System) {
              <mat-icon
                class="availability-icons"
                [class.greyscale]="aiConnection.isGreyscale"
                [glxyTooltip]="aiConnection.connection.connectionTypeName + ' ' + (aiConnection.tooltip | translate)"
                [svgIcon]="aiConnection.connection.connectionType"
              >
              </mat-icon>
            }
          }
        }
      </div>
    }
    <div class="actions">
      <!-- TODO: MEGA-2512 clean-up userCanChatWithEmployee -->
      @if (shouldShowChatButton()) {
        <button mat-flat-button color="primary" (click)="onChatButtonClick()">
          {{ 'AI_ASSISTANT.WORKFORCE.CHAT_BUTTON' | translate }}
        </button>
      }

      @if (showCTAButton()) {
        @if (userCanChatWithEmployee()) {
          <button mat-stroked-button (click)="ctaClicked.emit()">
            {{ aiAssistant().cta.label | translate }}
          </button>
        } @else {
          <button mat-flat-button color="primary" (click)="ctaClicked.emit()">
            {{ aiAssistant().cta.label | translate }}
          </button>
        }
      }
      @if (isDisabled()) {
        <glxy-badge>{{ 'AI_ASSISTANT.SHARED.UPGRADE' | translate }}</glxy-badge>
      } @else if (isComingSoon() && !showConfigButton()) {
        <glxy-badge>{{ 'AI_ASSISTANT.SHARED.COMING_SOON' | translate }}</glxy-badge>
      }
      @if (showConfigButton()) {
        <button mat-stroked-button [routerLink]="[aiAssistantConfigUrl()]" (click)="onConfigureButtonClick()">
          {{ 'AI_ASSISTANT.WORKFORCE.CONFIGURE_BUTTON' | translate }}
        </button>
      }
    </div>
  </div>
</div>
